"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCatalogEditEngines = void 0;
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@ant-design/icons");
var react_1 = __importStar(require("react"));
var messageContext_1 = require("../../hoc/messageContext");
var selectors_1 = require("../../redux/selectors");
var catalogCarSlice_1 = require("../../redux/slice/catalogCarSlice");
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var button_1 = __importDefault(require("antd/es/button"));
var popconfirm_1 = __importDefault(require("antd/es/popconfirm"));
var space_1 = __importDefault(require("antd/es/space"));
var table_1 = __importDefault(require("antd/es/table"));
var typography_1 = __importDefault(require("antd/es/typography"));
var input_number_1 = __importDefault(require("antd/es/input-number"));
var Title = typography_1.default.Title;
var CarCatalogEditEngines = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var id = (0, react_router_dom_1.useParams)().id;
    var catalogCar = (0, react_redux_1.useSelector)(selectors_1.catalogCarSelector).catalogCar;
    var _a = (0, messageContext_1.useMessageContext)(), showSuccess = _a.showSuccess, showError = _a.showError;
    var form = form_1.default.useForm()[0];
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var handleAdd = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalog_engines/"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                car_catalog_engine: __assign({ car_catalog_id: catalogCar === null || catalogCar === void 0 ? void 0 : catalogCar.id }, values),
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        setLoading(false);
                        dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
                        showSuccess('Двигатель успешно добавлен');
                    }
                    else {
                        setLoading(false);
                        showError('Ошибка при добавлении двигателя');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (engineId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalog_engines/").concat(engineId), {
                            method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        setLoading(false);
                        dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
                        showSuccess('Двигатель успешно удален');
                    }
                    else {
                        setLoading(false);
                        showError('Ошибка при удалении двигателя');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var columns = [
        {
            title: 'Наименование',
            dataIndex: 'name_engines',
            key: 'name_engines',
            render: function (text) { return react_1.default.createElement("strong", { key: text }, text); },
        },
        {
            title: 'Крутящий момент (Нм)',
            dataIndex: 'torque',
            key: 'torque',
        },
        {
            title: 'Мощность двигателя',
            dataIndex: 'power',
            key: 'power',
        },
        {
            title: 'Количество цилиндров',
            dataIndex: 'cylinders',
            key: 'cylinders',
        },
        {
            title: 'Объем двигателя',
            dataIndex: 'engine_volume',
            key: 'engine_volume',
        },
        {
            title: 'Рекомендуемое топливо',
            dataIndex: 'fuel_type',
            key: 'fuel_type',
        },
        {
            title: 'Тип двигателя',
            dataIndex: 'engine_type',
            key: 'engine_type',
        },
        {
            title: 'Действия',
            key: 'action',
            width: '20%',
            render: function (_, record) { return (react_1.default.createElement(space_1.default, { size: "middle" },
                react_1.default.createElement(popconfirm_1.default, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044C?", description: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044C?", onConfirm: function () {
                        handleDelete(record.id);
                    }, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442" },
                    react_1.default.createElement(button_1.default, { type: "link", danger: true, icon: react_1.default.createElement(icons_1.DeleteOutlined, null), loading: loading }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")))); },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Title, { level: 4, style: { marginTop: '20px', marginBottom: '20px' } }, "\u0422\u0438\u043F\u044B \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u0435\u0439"),
        catalogCar ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(table_1.default, { columns: columns, dataSource: catalogCar.car_catalog_engines.map(function (engine) { return (__assign(__assign({}, engine), { key: engine.id })); }), bordered: true, size: "middle", pagination: {
                    pageSize: 10,
                    showSizeChanger: false,
                    showTotal: function (total) { return "\u0412\u0441\u0435\u0433\u043E ".concat(total); },
                } }),
            react_1.default.createElement(Title, { level: 3, style: { marginTop: '20px' } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044C"),
            react_1.default.createElement(form_1.default, { form: form, layout: "inline", onFinish: handleAdd },
                react_1.default.createElement(form_1.default.Item, { name: "name_engines", rules: [{ required: true, message: 'Наименование двигателя обязательное' }] },
                    react_1.default.createElement(input_1.default, { placeholder: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435", style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { name: "torque", rules: [{ required: true, message: 'Значение крутящего момента обязательное' }] },
                    react_1.default.createElement(input_number_1.default, { placeholder: "\u041A\u0440\u0443\u0442\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 (\u041D\u043C)", style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { name: "cylinders", rules: [{ required: true, message: 'Количество цилиндров обязательное значение' }] },
                    react_1.default.createElement(input_number_1.default, { min: 1, max: 18, placeholder: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0446\u0438\u043B\u0438\u043D\u0434\u0440\u043E\u0432", style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { name: "power", rules: [{ required: true, message: 'Значение мощности обязательное' }] },
                    react_1.default.createElement(input_number_1.default, { placeholder: "\u041C\u043E\u0449\u043D\u043E\u0441\u0442\u044C \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044F", style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { name: "engine_volume", rules: [{ required: true, message: 'Значение объема двигателя обязательное' }] },
                    react_1.default.createElement(input_number_1.default, { step: 0.1, placeholder: "\u041E\u0431\u044A\u0435\u043C \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044F", style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { name: "fuel_type", rules: [{ required: true, message: 'Тип топлива обязателен' }] },
                    react_1.default.createElement(input_1.default, { placeholder: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C\u043E\u0435 \u0442\u043E\u043F\u043B\u0438\u0432\u043E", style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { name: "engine_type", rules: [{ required: true, message: 'Тип двигателя обязателен' }] },
                    react_1.default.createElement(input_1.default, { placeholder: "\u0422\u0438\u043F \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044F", style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, null,
                    react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", loading: loading }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044C"))))) : null));
};
exports.CarCatalogEditEngines = CarCatalogEditEngines;
